import Vue from "vue";

import {
  Button,
  Tabbar,
  TabbarItem,
  Icon,
  NavBar,
  Tab,
  Dialog,
  Tabs,
  GridItem,
  Grid,
  Field,
  Toast,
  CountDown,
  List,
  PullRefresh,
  RadioGroup,
  Radio,
  Popup,
  NoticeBar,
  Swipe,
  SwipeItem,
  Pagination,
  Uploader,
  Progress,
  NumberKeyboard,
  Sticky
} from "vant";

Vue.use(Dialog);
Vue.use(Button);
Vue.use(NumberKeyboard);
Vue.use(Tabbar);
Vue.use(Uploader);
Vue.use(TabbarItem);
Vue.use(Icon);
Vue.use(NavBar);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Field);
Vue.use(Toast);
Vue.use(CountDown);
Vue.use(List);

Vue.use(PullRefresh);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Popup);
Vue.use(NoticeBar);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Pagination);
Vue.use(Progress);
Vue.use(Sticky);
